import { Operator } from '@jexop/core';
import { isNumber, isString } from 'lodash';
import { I18n } from '../providers';
import { Nullable } from '../types';

export const formatNumber: Operator<string> = ({ value, format, type, fractionDigits, unit, unitDisplay }): Nullable<string> => {
  if (!isNumber(value)) {
    return null;
  }

  if (type === 'integer') {
    return Math.round(value).toString();
  }

  let val;
  switch (format) {
    case 'percentage':
      val = (value * 100).toFixed(2) + '%';
      break;
    case 'percentage-100':
      val = value.toString() + '%';
      break;
    case 'currency':
      val = '$' + value.toString();
      break;
    case 'voltage':
      val = (value / 1000).toFixed(3).replace(/\.?0+$/, '') + ' V';
      break;
    case 'unit': {
      const numberFormatOptions: Intl.NumberFormatOptions = {
        style: 'unit',
        unit: isString(unit) ? unit : 'liter',
        unitDisplay: (isString(unitDisplay) ? unitDisplay : 'narrow') as Intl.NumberFormatOptions['unitDisplay'],
      };
      if (isNumber(fractionDigits)) {
        numberFormatOptions.minimumFractionDigits = fractionDigits;
        numberFormatOptions.maximumFractionDigits = fractionDigits;
      }
      val = new Intl.NumberFormat(I18n.getInstance().language, numberFormatOptions).format(value);
      break;
    }
    default: {
      const numberFormatOptions: Intl.NumberFormatOptions = {};
      if (isNumber(fractionDigits)) {
        numberFormatOptions.minimumFractionDigits = fractionDigits;
        numberFormatOptions.maximumFractionDigits = fractionDigits;
      }
      val = new Intl.NumberFormat(I18n.getInstance().language, numberFormatOptions).format(value);
    }
  }
  return val;
};
